import React from "react";
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import {
  Circle as BulletActive,
  ExpandMoreRounded as ExpandIcon,
  ConfirmationNumberOutlined as VoucherIcon,
} from "@mui/icons-material";
import { useSelector } from "react-redux";

const voucherItemsConfig = [
  {
    permission: 12,
    label: "Creation of Voucher",
    to: "/voucher/vouchering",
    notificationKey: "Creation of Voucher",
    notificationArrayProp: "transactions",
    isLoadingProp: "isTransactionsLoading",
    notificationValue: "pending",
  },
  {
    permission: 11,
    label: "Filing of Voucher",
    to: "/voucher/filing",
    notificationKey: "Filing of Voucher",
    notificationArrayProp: "transactions",
    isLoadingProp: "isTransactionsLoading",
    notificationValue: "pending",
  },
  {
    permission: 30,
    label: "Filing of MC Voucher",
    to: "/voucher/managers_cheque/filing/",
    notificationKey: "Filing of MC Voucher",
    notificationArrayProp: "transactions",
    isLoadingProp: "isTransactionsLoading",
    notificationValue: "pending",
  },
  {
    permission: 10,
    label: "Reversal Request",
    to: "/voucher/reversing",
  },
  {
    permission: 12,
    label: "Returned/Held Vouchers",
    to: "/voucher/returned-vouchers",
    notificationKey: "Creation of Voucher",
    notificationArrayProp: "transactions",
    isLoadingProp: "isTransactionsLoading",
    notificationValue: "return",
  },
];

const SidebarVoucherDropdown = ({
  activeDropdown,
  user,
  transactions,
  shouldDisplayDotNotification,
  isTransactionsLoading,
  RouterLink,
  DisplayBubbleNotification,
}) => {
  const color = useSelector((state) => state.theme);
  const isActiveDropdown = Boolean(activeDropdown?.match(/voucher/gi));
  const isNotDocument = !Boolean(activeDropdown?.match(/document/gi));

  const allNotifications = {
    "Creation of Voucher": transactions,
    "Filing of Voucher": transactions,
    "Filing of MC Voucher": transactions,
  };

  const allLoadingStates = {
    isTransactionsLoading,
  };

  const hasNotifications = voucherItemsConfig.some(
    (item) =>
      user.permissions.includes(item.permission) &&
      item.notificationKey &&
      shouldDisplayDotNotification(allNotifications[item.notificationKey], item.notificationKey)
  );

  return (
    <Accordion
      defaultExpanded={/associate|specialist/i.test(user.role)}
      elevation={0}
      square
      disableGutters
    >
      <AccordionSummary
        className={
          isActiveDropdown && isNotDocument
            ? `FstoSidebarActiveDropdown-root ${color}`
            : `FstoSidebarDropdown-root ${color}`
        }
        expandIcon={<ExpandIcon htmlColor="white" />}
      >
        <VoucherIcon />
        <Typography variant="sidebar">Voucher</Typography>
        {!isTransactionsLoading && hasNotifications ? (
          <BulletActive className="FstoSidebarActiveNotif-root" />
        ) : null}
      </AccordionSummary>

      <AccordionDetails className="FstoSidebarAccordionDetails-root">
        {voucherItemsConfig.map(
          (item) =>
            user.permissions.includes(item.permission) && (
              <RouterLink className="FstoSidebarLink-root" to={item.to} key={item.label}>
                {item.label}
                {item.notificationKey && !allLoadingStates[item.isLoadingProp] && (
                  <DisplayBubbleNotification
                    notificationArray={allNotifications[item.notificationKey]}
                    permission={item.notificationKey}
                    value={item?.notificationValue}
                  />
                )}
              </RouterLink>
            )
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default SidebarVoucherDropdown;
